const mapItemsToSelectOption = (items: string[]) =>
  items.map((filter) => ({
    value: filter,
    label: `${filter.charAt(0).toUpperCase()}${filter.slice(1)}`,
  }));

export { mapItemsToSelectOption };
